import React, { useState } from "react";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../../../context/useFetch";
import { useUserData } from "../../../../context/UserDataContext";
import PanelTemplate from "../../../shares/PanelTemplate";
import PanelFilter from "../../../shares/PanelFilter";
import MuiPagination from "../../../shares/MuiPagination";
import PanelTable from "../../../shares/PanelTable";
import OrderDetails from "../current-orders/OrderDetails";
import MuiButton from "../../../shares/MuiButton";
import PrintIcon from "@mui/icons-material/Print";

const headersList = [
  { colName: "unique_id", name: "کد سفارش" },
  { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
  { colName: "created_at", name: "تاریخ تحویل سفارش" },
  { colName: "details", name: "مشاهده جزییات" },
];
const mobileHeadersList = [
  { colName: "unique_id", name: "کد سفارش" },
  { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
  { colName: "created_at", name: "تاریخ تحویل سفارش" },
];

const dataKey = ["unique_id", "created_at", "created_at"];

// import Others files
const DeliveredOrders = (props) => {
  let windowWidth = window.screen.width;
  const { userData } = useUserData();

  const [isFilterOn, setIsFilterOn] = useState(false);
  const [dateFilter, setDateFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(undefined);

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const [requestList, setRequestList] = useState({ results: [] });
  const getRequestListApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/provider_get_complete_admin_request`,
    params: {
      date: dateFilter,
    },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  // Filter
  const filterList = [
    {
      type: "datePicker",
      label_fa: "تاریخ تحویل سفارش",
      label_en: "date",
      state: dateFilter,
    },
  ];

  // Table
  const buttonsList = [
    {
      label: "جزییات سفارش",
      component: (it) => (
        <OrderDetails selectedRow={it} getRequestListApi={getRequestListApi} />
      ),
    },
  ];
  // const actionsList = [
  //   {
  //     label: "قبول سفارش",
  //     component: () => <SubmitOrder />,
  //   },
  // ];

  const update_filter = (state, e) => {
    if (state == "date") setDateFilter(e);
  };
  const filter = () => {
    if (dateFilter !== null) {
      setIsFilterOn(true);
      getRequestListApi.reFetch();
    }
  };
  const reset_filter = () => {
    setDateFilter(null);
  };
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRequestList({ results: [] });
    getRequestListApi.reFetch();
  };

  const handelPrintReport = () => {
    // navigate(
    //   `/print-customers-current-orders-by-bangle/${codeFilter}/${nameFilter}/${brandFilter}/${orderItemStatusFilter}/${orderItemStatusZeroFilter}`
    // );
    window.open(
      `/print-customers-complete-orders-by-bangle`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };
  return (
    <>
      <PanelTemplate sidebarActiveLink="p-delivered-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های تحویل داده‌شده</span>
          </div>

          <PanelFilter
            header="فیلتر براساس‌ تاریخ تحویل سفارش:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="flex justify-end">
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <PanelTable
            header="لیست سفارش‌های تحویل داده‌شده:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={requestList.results}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={[]}
            icon={<AddShoppingCartIcon />}
            // setSelectedRow={setSelectedRow}
          />

          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default DeliveredOrders;
